import styled from 'styled-components';
import { container, fontSize, spacing } from '../../../theme';

export const StyledContainer = styled.section`
  max-width: ${container('md')};
  margin: auto;
  padding: ${spacing('xl3')} ${spacing('md')};
  text-align: center;

  p {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }
`;
